<template>
  <v-navigation-drawer :model-value="dataStore.getShowAdvancedPanel" location="right" :scrim="false"
    v-bind:width="500" elevation="10" temporary>
    <OperationalComponent type="create" icon="ecc:ecc-ALLARM-DeviceHight" :title="$t('createCustomAlarm')"
      :closeDialog="dataStore.closeAdvanced" 
      @confirmDialog="onCreateClick" :confirmLoading="isFetching" :acceptDisabled="!confirmButtonEnabled">
      <br />
      
      <v-text-field :label="$t('Name')" v-model="name" density="compact"></v-text-field>

      <div>



      </div>

    </OperationalComponent>
  </v-navigation-drawer>
</template>

<script type="ts">
import { dataStore } from '../../stores/data';
import OperationalComponent from '../UIComponents/OperationalComponent.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  emits: ["customAlarmCreated"], 
  data() {
    return {
      dataStore: dataStore(),
      name: '',
      isFetching: false,
      confirmButtonEnabled: false,
    }
  },
  components: {
    OperationalComponent,
  },
  methods: {
    async onCreateClick(event) {
      this.$emit('customAlarmCreated', true);
      this.dataStore.closeCreate(event);
    },
    checkConfirmButtonEnabled() {
      if (this.name.trim().length < 1) {
        this.confirmButtonEnabled = false;
        return
      }

      this.confirmButtonEnabled = true;
    }
  },
  watch: {
    name(v) {
      this.checkConfirmButtonEnabled();
    },
  },
});
</script>